"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputNumerico = void 0;
//#region Imports
var estiloInputNumerico = require("./InputNumerico.module.scss");
var react_1 = __importStar(require("react"));
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Icone_1 = require("../../Icone/Icone");
var Cores_1 = require("../../Cores/Cores");
var TipoInputNumerico_1 = require("../../../enums/TipoInputNumerico");
//#endregion
var InputNumerico = function (_a) {
    var id = _a.id, _b = _a.placeholder, placeholder = _b === void 0 ? "" : _b, valor = _a.valor, _c = _a.label, label = _c === void 0 ? false : _c, _d = _a.textoLabel, textoLabel = _d === void 0 ? "Input Numérico:" : _d, _e = _a.variante, variante = _e === void 0 ? "regular" : _e, _f = _a.desabilitado, desabilitado = _f === void 0 ? false : _f, _g = _a.tamanho, tamanho = _g === void 0 ? "medium" : _g, _h = _a.readonly, readonly = _h === void 0 ? false : _h, _j = _a.autofocus, autofocus = _j === void 0 ? false : _j, conteudoDeAjuda = _a.conteudoDeAjuda, _k = _a.casasInteiras, casasInteiras = _k === void 0 ? 6 : _k, _l = _a.casasDecimais, casasDecimais = _l === void 0 ? 3 : _l, _m = _a.exibirMilhar, exibirMilhar = _m === void 0 ? false : _m, _o = _a.botaoDeLimpar, botaoDeLimpar = _o === void 0 ? true : _o, tipo = _a.tipo, isNullavel = _a.isNullavel, onChange = _a.onChange;
    //#region States e Variáveis
    var style = textoLabel || conteudoDeAjuda ? { gap: "8px" } : {};
    var estiloVariacao = estiloInputNumerico[variante];
    var disabledStyle = estiloInputNumerico.disabled || "";
    var inputFieldSize = estiloInputNumerico[tamanho] || "";
    var inputfieldStyle = desabilitado ? disabledStyle : estiloVariacao;
    var inputRef = (0, react_1.useRef)(null);
    var configuracao = TipoInputNumerico_1.configuracoesPorTipo[tipo !== null && tipo !== void 0 ? tipo : "padrao"];
    var casasDecimaisEfetivas = casasDecimais !== null && casasDecimais !== void 0 ? casasDecimais : configuracao.casasDecimais;
    var exibirMilharEfetivo = exibirMilhar !== null && exibirMilhar !== void 0 ? exibirMilhar : configuracao.exibirMilhar;
    var _p = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _p[0], setCor = _p[1];
    var _q = (0, react_1.useState)(false), emFoco = _q[0], setEmFoco = _q[1];
    var _r = (0, react_1.useState)("20px"), iconSize = _r[0], setIconSize = _r[1];
    var _s = (0, react_1.useState)(globalMu_1.default.isNotNullOrEmptyOrUndefined(valor) ? globalMu_1.default.formatarValorNumerico(valor !== null && valor !== void 0 ? valor : 0, casasDecimais !== null && casasDecimais !== void 0 ? casasDecimais : 2) : ""), inputValue = _s[0], setInputValue = _s[1];
    //#endregion
    //#region Handlers
    var handleChange = function (event) {
        var input = event.target.value;
        if (!/^[\d.,]*$/.test(input))
            return;
        var converterValorInput = input.replace(",", ".");
        var apenasDigitos = input.replace(/[.,]/g, "");
        var valorVisual = input;
        var possuiSeparador = input.includes(".") || input.includes(",");
        if (casasDecimaisEfetivas > 0) {
            if (possuiSeparador) {
                var _a = input.split(/[.,]/), _b = _a[0], parteInteira = _b === void 0 ? "" : _b, _c = _a[1], parteDecimal = _c === void 0 ? "" : _c;
                if (parteInteira.length > casasInteiras || parteDecimal.length > casasDecimaisEfetivas)
                    return;
                valorVisual = parteInteira + "." + parteDecimal;
            }
            else {
                if (apenasDigitos.length > casasInteiras + casasDecimaisEfetivas)
                    return;
                if (apenasDigitos.length > casasInteiras) {
                    valorVisual =
                        apenasDigitos.slice(0, casasInteiras) +
                            "." +
                            apenasDigitos.slice(casasInteiras);
                }
            }
        }
        else {
            if (apenasDigitos.length > casasInteiras)
                return;
            valorVisual = apenasDigitos;
        }
        setInputValue(valorVisual);
        var valorConvertido = parseFloat(converterValorInput);
        onChange(isNaN(valorConvertido) ? (isNullavel ? null : 0) : valorConvertido);
    };
    var handleBlur = function () {
        setEmFoco(false);
        var valorAtual = inputValue;
        if (valorAtual === "") {
            return;
        }
        valorAtual = valorAtual.replace(",", ".");
        var numero = parseFloat(valorAtual);
        var numeroFormatado = numero.toFixed(casasDecimaisEfetivas);
        var valorFormatado = exibirMilhar
            ? globalMu_1.default.formatarMilhar(numeroFormatado.replace(".", ","))
            : numeroFormatado.replace(".", ",");
        setInputValue(valorFormatado);
    };
    var handlePaste = function (event) {
        var _a, _b;
        event.preventDefault();
        var pasted = event.clipboardData.getData("text").replace(/\s/g, "").replace(/[^\d]/g, "");
        var input = event.currentTarget;
        var selectionStart = (_a = input.selectionStart) !== null && _a !== void 0 ? _a : 0;
        var selectionEnd = (_b = input.selectionEnd) !== null && _b !== void 0 ? _b : 0;
        var valorAtual = (inputValue || "").replace(/[.,]/g, "");
        var novoValor = valorAtual.slice(0, selectionStart) +
            pasted +
            valorAtual.slice(selectionEnd);
        var totalCasas = casasInteiras + casasDecimaisEfetivas;
        var valorNumerico = novoValor.slice(0, totalCasas);
        var valorFinal = "";
        if (valorNumerico.length <= casasInteiras) {
            valorFinal = "".concat(valorNumerico, ".").concat("0".repeat(casasDecimaisEfetivas));
        }
        else {
            var parteInteira = valorNumerico.slice(0, casasInteiras);
            var parteDecimal = valorNumerico.slice(casasInteiras);
            parteDecimal = parteDecimal.padEnd(casasDecimaisEfetivas, "0").slice(0, casasDecimaisEfetivas);
            valorFinal = "".concat(parteInteira, ".").concat(parteDecimal);
        }
        setInputValue(valorFinal);
        onChange(Number(valorFinal));
    };
    var handleFocus = function () {
        setEmFoco(true);
        var valorAtual = inputValue;
        if (valorAtual) {
            valorAtual = globalMu_1.default.removerMilhar(valorAtual).replace(",", ".");
        }
        setInputValue(valorAtual);
    };
    var limparCampo = function () {
        setInputValue("");
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
    };
    //#endregion
    //#region Botão Limpar
    var BotaoLimpar = (react_1.default.createElement("div", { onClick: limparCampo, className: "\n                ".concat(estiloInputNumerico.botaoLimpar, " \n                ").concat(inputFieldSize, " \n                ").concat(estiloVariacao, " \n                ").concat(desabilitado ? disabledStyle : "", "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: "close", largura: iconSize, altura: iconSize, desabilitado: desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var metragem = (react_1.default.createElement("div", { className: "\n                ".concat(estiloInputNumerico.icones, " \n                ").concat(inputFieldSize, " \n                ").concat(estiloVariacao, " \n                ").concat(desabilitado ? disabledStyle : "", "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: "squared_meter", largura: iconSize, altura: iconSize, desabilitado: desabilitado })));
    var monetario = (react_1.default.createElement("div", { className: "\n                ".concat(estiloInputNumerico.icones, " \n                ").concat(inputFieldSize, " \n                ").concat(estiloVariacao, " \n                ").concat(desabilitado ? disabledStyle : "", "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: "reais", largura: iconSize, altura: iconSize, desabilitado: desabilitado })));
    //#endregion
    //#region Conteúdo de Ajuda
    var ConteudoAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || "", desabilitado: desabilitado, estado: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) || variante, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    //#endregion
    //#region useEffect
    (0, react_1.useEffect)(function () {
        if (valor !== null && valor !== undefined && !emFoco) {
            var valorFormatado = globalMu_1.default.formatarValorNumerico(valor, casasDecimaisEfetivas);
            var novoValor = exibirMilhar ? globalMu_1.default.formatarValorNumerico(valor, casasDecimaisEfetivas) : globalMu_1.default.removerMilhar(valorFormatado);
            if (novoValor !== inputValue)
                setInputValue(novoValor);
        }
    }, [valor, limparCampo]);
    (0, react_1.useEffect)(function () {
        switch (tamanho) {
            case "small":
                setIconSize("16px");
                break;
            case "medium":
                setIconSize("20px");
                break;
        }
    }, [tamanho]);
    (0, react_1.useEffect)(function () {
        desabilitado && setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        if (!desabilitado) {
            switch (variante) {
                case "success":
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case "error":
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                default:
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
            }
        }
    }, [variante, desabilitado]);
    //#endregion
    //#region Return
    return (react_1.default.createElement("div", { className: estiloInputNumerico.container, style: style },
        react_1.default.createElement("div", { className: estiloInputNumerico.conteudo },
            label && react_1.default.createElement(Label_1.Label, { texto: textoLabel }),
            react_1.default.createElement("div", { className: "".concat(estiloInputNumerico.input, " ").concat(inputFieldSize, " ").concat(inputfieldStyle) },
                tipo === "monetario" ? monetario : undefined,
                react_1.default.createElement("input", { id: id, type: "text", ref: inputRef, inputMode: "numeric", readOnly: readonly, autoFocus: autofocus, value: inputValue, disabled: desabilitado, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onPaste: handlePaste, placeholder: placeholder }),
                (botaoDeLimpar && !globalMu_1.default.isNullOrEmpty(inputValue) && !desabilitado)
                    && BotaoLimpar,
                tipo === "metragem" ? metragem : undefined)),
        conteudoDeAjuda && ConteudoAjuda));
    //#endregion
};
exports.InputNumerico = InputNumerico;
